import React, {useRef, useState} from 'react';
import play from "../component/icon/play-button-arrowhead.png"
import pause from "../component/icon/pause.png"
import next from "../component/icon/next.png"
import back from "../component/icon/back.png"
import timerIcon from "../component/icon/timer.png"
import repeatTrack from "../component/icon/repeat-track.png"
import {BarsOutlined} from '@ant-design/icons';
import {useNavigate, useParams} from 'react-router-dom';
import {useCookies} from 'react-cookie';
import formatSecondToTime from "../utils/formatSecondToTime";
import {Dropdown} from "antd";
import {SPEED_MODE} from "../mocks";

function Control({
                     onPlay,
                     onPause,
                     onSeekToNext,
                     onSeekToBack,
                     onScheduleTimeOff,
                     onLoop,
                     loopValue,
                     onReset,
                     current,
                     setCurrent,
                     setNext,
                     setCount,
                     changeRepeatMode,
                     recoverAutoScrollImmediately,
                     isPlaying,
                     setisPlaying,
                     songs,
                     setSongs,
                     audioElem,
                     currentSong,
                     setCurrentSong,
                     repeatMode,
                     changeSpeedMode,
                     speed,
                     changeSoundMode,
                     isPlaylist,
                     openModal,
                     videoPlayerRef
                 }) {
    const clickRef = useRef();
    const {lesson_id} = useParams();
    const [cookies, setCookie, removeCookie] = useCookies(["user"]);
    const [soundMode, setSoundMode] = useState('volume-high');
    const navigate = useNavigate();

    const timer = [
        {
            label: '2h',
            value: 120,
        },
        {
            label: '1h 30m',
            value: 90,
        },
        {
            label: '1h',
            value: 60,
        },
        {
            label: '30m',
            value: 30,
        },
        {
            label: '15m',
            value: 15,
        },
        {
            label: 'Off',
            value: 0,
        },
    ];

    const loop = [
        {
            label: '∞',
            value: 200,
        },
        {
            label: '5',
            value: 5,
        },
        {
            label: '4',
            value: 4,
        },
        {
            label: '3',
            value: 3,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: 'Off',
            value: 0,
        },
    ];

    const PlayPause = () => {
        try {
            if (isPlaying === true) {
                onPause();
            } else {
                onPlay();
            }
            setisPlaying(!isPlaying);
        } catch (e) {
            console.log(e)
        }
    }
    const skipForward = (time) => {
        if (time === 'forward' && audioElem.current?.currentTime) {
            onSeekToNext();
        } else if (time === 'backward' && audioElem.current?.currentTime) {
            onSeekToBack();
        }
    }

    const checkWidth = (e) => {
        try {
            if (!clickRef.current) return;
            const rect = clickRef.current.getBoundingClientRect();
            const width = rect.width;
            const offset = Math.max(0, Math.min(e.clientX - rect.left, width));

            const divprogress = (offset / width) * 100;
            const targetTime = (divprogress / 100) * (currentSong?.length || 0);
            if (audioElem?.current) {
                audioElem.current.currentTime = targetTime;
                audioElem.current.play().then(() => {
                    if (typeof setisPlaying === 'function') setisPlaying(true);
                }).catch((err) => console.log('Control auto-play handled:', err));
            }
            videoPlayerRef?.current?.seekTo(targetTime);
            if (typeof setNext === 'function') setNext(0);
            if (typeof setCount === 'function') setCount(1);
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <>
            <div className="w-full flex flex-row pt-5 px-2 bg-gradient-to-r from-red-500 to-red-800 items-center">
                <p className="w-1/12 text-2xl font-semibold text-center text-white">{formatSecondToTime(audioElem.current?.currentTime || 0)}</p>
                <div className="w-10/12 bg-gray-200 h-[6px] rounded-full cursor-pointer" onClick={checkWidth}
                     ref={clickRef}>
                    <div className="w-0 h-full bg-sky-600 rounded-[30px]"
                         style={{width: `${currentSong.progress + "%"}`}}></div>
                </div>
                <p className="w-1/12 text-2xl font-semibold text-center text-white">{formatSecondToTime(currentSong?.length || 0)}</p>
            </div>
            <center>
                <div className='p-4 bg-gradient-to-r from-red-500 to-red-800 flex flex-row justify-center'>
                    <Dropdown
                        className='mx-5 h-auto rounded-full px-4 bg-orange-600 flex items-center cursor-pointer'
                        overlayStyle={{maxHeight: 400, overflow: 'auto'}}
                        menu={{
                            items: timer.map((el, i) => {
                                return {
                                    label: (<div onClick={() => {
                                        onScheduleTimeOff(el.value);
                                    }}>
                                        {el.label}
                                    </div>),
                                    key: i
                                }
                            }),
                            selectable: true,
                        }}
                    >
                        <p className='text-white text-xl font-semibold'>
                            <img src={timerIcon} className='w-10 h-10'/>
                        </p>
                    </Dropdown>
                    <Dropdown
                        className='mx-5 h-auto rounded-full px-9 bg-orange-600 flex items-center cursor-pointer'
                        overlayStyle={{maxHeight: 400, overflow: 'auto'}}
                        menu={{
                            items: SPEED_MODE.map((el, i) => {
                                return {
                                    label: (<div onClick={() => {
                                        changeSpeedMode(el);
                                    }}>
                                        {el}X
                                    </div>),
                                    key: i
                                }
                            }),
                            selectable: true,
                        }}
                    >
                        <p className="w-0 text-xl font-semibold flex item-center text-center justify-center text-white">{speed + 'X'}</p>
                    </Dropdown>
                    <button type="button" className='mx-5 rounded-full p-4 bg-orange-600'
                            onClick={() => skipForward('backward')}>
                        <img src={back} className='w-10 h-10'/>
                    </button>
                    {isPlaying ?
                        <button type="button" className='mx-5 rounded-full p-4 bg-orange-600' onClick={PlayPause}>
                            <img src={pause} className='w-10 h-10'/>
                        </button>
                        :
                        <button type="button" className='mx-5 bg-orange-600 p-4 rounded-full' onClick={PlayPause}>
                            <img src={play} className='w-10 h-10'/>
                        </button>
                    }
                    <button type="button" className='mx-5 rounded-full p-4 bg-orange-600'
                            onClick={() => skipForward('forward')}>
                        <img src={next} className='w-10 h-10'/>
                    </button>
                    <div className='mx-5 relative'>
                        {/**
                         * repeatMode expected values (common):
                         * - 'one'  => loop single sentence (show red "1" badge)
                         * - 'track' => loop whole track (highlight background)
                         * - any other/falsy => no loop (dim)
                         */}
                        <button
                            type="button"
                            onClick={() => changeRepeatMode && changeRepeatMode()}
                            className={`rounded-full p-3 transition-all flex items-center justify-center ${
                                repeatMode === 'track' ? 'bg-white/10 text-white shadow-lg' : (repeatMode === 'one' ? 'bg-transparent text-white' : 'bg-transparent text-gray-300 opacity-40')
                            }`}
                        >
                            <img src={repeatTrack} className='w-10 h-10' alt="repeat" />
                        </button>

                        {repeatMode === 'one' && (
                            <div className="absolute -top-3 -right-3 bg-red-600 text-white text-sm font-extrabold rounded-full w-5 h-5 flex items-center justify-center shadow-lg border-2 border-white/10">1</div>
                        )}
                    </div>
                    {!isPlaylist && <button type="button" className='mx-5 rounded-full p-4 bg-orange-600'
                                            onClick={() => cookies?.user ? openModal() : navigate('/login')}>
                        <BarsOutlined className='w-10 h-10 flex justify-center text-white text-4xl font-bold'/>
                    </button>}
                </div>
            </center>
        </>
    );
}

export default Control;
